
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/assignment-index/jst/CreateGroup';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function", self=this;

function program1(depth0,data) {
  
  
  return "form-horizontal";
  }

function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <div class=\"ag-settings-weights-message alert\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.create_group")
  },data:data},helper ? helper.call(depth0, "assignment_group_weights_and_drop_rules_can_t_be_e_7b5f305d", "Assignment group weights and drop rules can't be edited because there are assignments in one of the groups whose due dates are closed.", options) : helperMissing.call(depth0, "t", "assignment_group_weights_and_drop_rules_can_t_be_e_7b5f305d", "Assignment group weights and drop rules can't be edited because there are assignments in one of the groups whose due dates are closed.", options)))
    + "</div>\n    ";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <div class=\"control-group\">\n      <div class=\"controls\">\n        <input\n          type=\"text\"\n          id=\"ag_";
  if (helper = helpers.label_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.label_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_group_weight\"\n          class=\"span1 group_weight\"\n          name=\"group_weight\"\n          value=\"";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.group_weight), {hash:{},inverse:self.noop,fn:self.program(6, program6, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"\n          ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.can_change_weighting), {hash:{},inverse:self.noop,fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        />\n        <label style=\"display:inline-block\" for=\"ag_";
  if (helper = helpers.label_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.label_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_group_weight\">\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.create_group")
  },data:data},helper ? helper.call(depth0, "assignments.create_group.percent_of_total", "% of total grade", options) : helperMissing.call(depth0, "t", "assignments.create_group.percent_of_total", "% of total grade", options)))
    + "\n        </label>\n      </div>\n    </div>\n    ";
  return buffer;
  }
function program6(depth0,data) {
  
  var helper, options;
  return escapeExpression((helper = helpers.n || (depth0 && depth0.n),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.group_weight), options) : helperMissing.call(depth0, "n", (depth0 && depth0.group_weight), options)));
  }

function program8(depth0,data) {
  
  
  return "readonly";
  }

function program10(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      <hr/>\n      <fieldset>\n        <legend class=\"drop_rules_section\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.create_group")
  },data:data},helper ? helper.call(depth0, "number_of_scores_to_ignore_for_each_student_fb94e818", "Number of scores to ignore for each student", options) : helperMissing.call(depth0, "t", "number_of_scores_to_ignore_for_each_student_fb94e818", "Number of scores to ignore for each student", options)))
    + "</legend>\n\n        <div class=\"control-group\">\n          <label class=\"control-label\" for=\"ag_";
  if (helper = helpers.label_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.label_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_drop_lowest\">\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.create_group")
  },data:data},helper ? helper.call(depth0, "assignments.create_group.drop_lowest", "Lowest Scores:", options) : helperMissing.call(depth0, "t", "assignments.create_group.drop_lowest", "Lowest Scores:", options)))
    + "\n          </label>\n          <div class=\"controls\">\n            <input\n              type=";
  if (helper = helpers.number_input) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.number_input); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n              id=\"ag_";
  if (helper = helpers.label_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.label_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_drop_lowest\"\n              class=\"span1 field\"\n              name=\"rules[drop_lowest]\"\n              value=\""
    + escapeExpression((helper = helpers.n || (depth0 && depth0.n),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.drop_lowest), options) : helperMissing.call(depth0, "n", (depth0 && depth0.drop_lowest), options)))
    + "\"\n              min=\"0\"\n              ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.can_change_weighting), {hash:{},inverse:self.noop,fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            />\n          </div>\n        </div>\n        <div class=\"control-group\">\n          <label class=\"control-label\" for=\"ag_";
  if (helper = helpers.label_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.label_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_drop_highest\">\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.create_group")
  },data:data},helper ? helper.call(depth0, "assignments.create_group.drop_highest", "Highest Scores:", options) : helperMissing.call(depth0, "t", "assignments.create_group.drop_highest", "Highest Scores:", options)))
    + "\n          </label>\n          <div class=\"controls\">\n            <input\n              type=";
  if (helper = helpers.number_input) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.number_input); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n              id=\"ag_";
  if (helper = helpers.label_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.label_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_drop_highest\"\n              class=\"span1 field\"\n              name=\"rules[drop_highest]\"\n              value=\""
    + escapeExpression((helper = helpers.n || (depth0 && depth0.n),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.drop_highest), options) : helperMissing.call(depth0, "n", (depth0 && depth0.drop_highest), options)))
    + "\"\n              min=\"0\"\n              ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.can_change_weighting), {hash:{},inverse:self.noop,fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            />\n          </div>\n        </div>\n\n        <hr/>\n        <div class=\"control-group\">\n          <label class=\"control-label\" id=\"ag_";
  if (helper = helpers.label_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.label_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_never_drop\">\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.create_group")
  },data:data},helper ? helper.call(depth0, "assignments.create_group.never_drop", "Never Drop:", options) : helperMissing.call(depth0, "t", "assignments.create_group.never_drop", "Never Drop:", options)))
    + "\n          </label>\n          <div class=\"controls never_drop_rules_group\">\n          </div>\n        </div>\n      </fieldset>\n    ";
  return buffer;
  }

  buffer += "<div class=\"form-dialog-content\">\n  <div class=\"";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.small_tablet), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n    ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.can_change_weighting), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n    <div class=\"control-group\">\n      <label class=\"control-label\" for=\"ag_";
  if (helper = helpers.label_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.label_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_name\">\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.create_group")
  },data:data},helper ? helper.call(depth0, "assignments.create_group.group_name", "Group Name:", options) : helperMissing.call(depth0, "t", "assignments.create_group.group_name", "Group Name:", options)))
    + "\n      </label>\n      <div class=\"controls\">\n        <input\n          type=\"text\"\n          id=\"ag_";
  if (helper = helpers.label_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.label_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_name\"\n          name=\"name\"\n          value=\"";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n          placeholder='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.create_group")
  },data:data},helper ? helper.call(depth0, "assignments.create_group.example_group_name", "e.g., Essay Group 1", options) : helperMissing.call(depth0, "t", "assignments.create_group.example_group_name", "e.g., Essay Group 1", options)))
    + "'\n        />\n      </div>\n    </div>\n\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.show_weight), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.editable_drop), {hash:{},inverse:self.noop,fn:self.program(10, program10, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n</div>\n<div class=\"form-controls\">\n  <button\n    class=\"cancel_button btn dialog_closer\"\n    type=\"button\"\n  >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.create_group")
  },data:data},helper ? helper.call(depth0, "assignments.create_group.cancel", "Cancel", options) : helperMissing.call(depth0, "t", "assignments.create_group.cancel", "Cancel", options)))
    + "</button>\n  <button\n    class=\"create_group btn btn-primary\"\n    data-text-while-loading='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.create_group")
  },data:data},helper ? helper.call(depth0, "assignments.create_group.saving", "Saving...", options) : helperMissing.call(depth0, "t", "assignments.create_group.saving", "Saving...", options)))
    + "'\n    type=\"submit\"\n  >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.create_group")
  },data:data},helper ? helper.call(depth0, "assignments.create_group.save", "Save", options) : helperMissing.call(depth0, "t", "assignments.create_group.save", "Save", options)))
    + "</button>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  